export default __webpack_public_path__ + "static/media/logo138x75black.975996e0.png";